import React from "react";
import { type DropdownWithoutOptionsProps } from "../models";
import BaseReactSelectDropdown from "./BaseReactSelectDropdown";

const PaymentMethodDropdown = (props: DropdownWithoutOptionsProps<server.dto.PaymentMethod, server.dto.PaymentMethods>) => {
  return <BaseReactSelectDropdown
    excludeKeys={props.excludeKeys}
    options={serverReference.paymentMethods}
    getLabel={p => p.text}
    getValue={(t) => t.value}
    value={props.value}
    onChange={props.onChange}
    onEsc={props.onEsc}
    config={props.config}
  />;
};

export default PaymentMethodDropdown;